import React from 'react'
import {Tags as TagsTPA, TagsAlignment, TagsSize, TagsSkin} from 'wix-ui-tpa/cssVars'
import classNames from 'classnames'
import {classes} from './tags.st.css'
import {TagsProps} from './index'

export const Tags: React.FC<TagsProps> = ({className, items}) => (
  <TagsTPA
    className={classNames(classes.tags, className)}
    alignment={TagsAlignment.left}
    skin={TagsSkin.light}
    size={TagsSize.small}
    onClick={() => null}
    items={items}
  />
)
